export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    /* istanbul ignore next */
    reader.onerror = (error) => reject(new Error(JSON.stringify(error)));
  });
